import gql from 'graphql-tag';

export const getSelectedCourse = gql`
  query getSelectedCourse($id: uuid! , $userId: uuid!) {
    courses_by_pk(id: $id) {
      id
      course_name
      is_featured
      number_of_seats
      address
      attachments
      course_event_info
      presenters
      seo_metadata
      sponsor_by_image
      afterwards_price
      cpd_points
      early_bird_price
      community_id
    community_user_type
      max_subscribers
      price_in_aud
      price_in_usd
      company_name
      complete_details
      contact_email
      contact_name
      contact_phone
      contact_website
      register_link
      description
      early_bird_end_date
      endDate
      event_type
      image
      learning_objectives
      
      refund_policy
      short_id
      short_info
      startDate
      status
      terms
      topics_included
      video
      webinar_link
      created_at
      scheduled_at
      updated_at
      course_category_id
      created_by_id
      course_banner_video
      course_gallery
      active_status
      startTime
      endTime
      type
      course_banner_image
      facebook_link
      instagram_link
      linkedin_link
      youtube_link
     
      course_registered_users(where: { from_id: { _eq: $userId } }) {
        course_id
        from_id
        status
      }

        course_registered_users_aggregate (where: { status: { _neq: "CANCELLED" } }) {
        aggregate {
          count
        }
      }

    }
  }
`;


// query.ts
export const getRelatedCourse = gql`
  query getRelatedCourse($limit: Int, $offset: Int, $where: courses_bool_exp) {
    courses(
      where: $where
      order_by: { created_at: desc }
      limit: $limit
      offset: $offset
    ) {
      id
      type
      active_status
      status
      created_at
      updated_at
      community_id
      course_category_id
      short_id
      course_name
      short_info
      image
      video
      complete_details
      address
      price_in_aud
      price_in_usd
      webinar_link
      startDate
      endDate
      presenters
      description
      course_event_info
      early_bird_end_date
      topics_included
      learning_objectives
      event_type
      created_by_id
      company_name
      cpd_points
      number_of_seats
      early_bird_price
      afterwards_price
      course_gallery
      course_banner_video
      course_banner_image
    }
  }
`;


// new

// learing-hub-query.ts
// export const getAllCoursedata = gql`
//   query getAllLearningHubList(
//   $limit: Int!
//   $offset: Int!
//   $where: courses_bool_exp!
// ) {
//   courses(
//     limit: $limit
//     offset: $offset
//     order_by: { created_at: desc }
//     where: {
//       status: { _eq: "APPROVE" }
//       active_status: { _eq: "ACTIVE" }
//       _and: [$where]
//     }
//   ) {
//     id
//     presented_by_name
//     course_name
//     cpd_points
//     address
//     company_name
//     presenters
//     max_subscribers
//     endDate
//     event_type
//     startDate
//     status
//     created_at
//     course_category_id
//     active_status
//     type
//     course_banner_image
//   }
// }

// `;

export const getAllCoursedata = gql`
  query getAllLearningHubList(
  $limit: Int!
  $offset: Int!
  $where: courses_bool_exp!
) {
  courses(
    limit: $limit
    offset: $offset
    order_by: { created_at: desc }
    where: {
      status: { _eq: "APPROVE" }
      active_status: { _eq: "ACTIVE" }
      _and: [$where]
    }
  ) {
    id
    course_name
    cpd_points
    created_by_id
    address
    company_name
    presenters
    max_subscribers
    endDate
    event_type
    startDate
    status
    created_at
    course_category_id
    active_status
    type
    course_banner_image
    number_of_seats
    startTime
    endTime

    course_registered_users_aggregate (where: { status: { _neq: "CANCELLED" } }) {
      aggregate {
        count
      }
    }

  }
}

`;

export const GET_REGISTERED_COUNT = gql`
  query getRegisteredCount($courseId: uuid!) {
    course_registered_users_aggregate(
      where: {
        _and: [
          { course_id: { _eq: $courseId } }
          { status: { _neq: "CANCELLED" } }
        ]
      }
    ) {
      aggregate {
        count
      }
    }
  }
`;